export default function Faq() {
  return (
    <article>
      <h1>Questions</h1>
      <div className="card-grid">
        <section className="card">
          <h2>Is this a listing site?</h2>
          <p>No. REChecklist is a decision companion: checklists, portfolios, notes, and archive.</p>
        </section>
        <section className="card">
          <h2>Do buyers and sellers share a workspace?</h2>
          <p>
            Never. Buyer journeys and seller portfolios stay on separate routes, nav, and storage.
          </p>
        </section>
        <section className="card">
          <h2>What do brokers see?</h2>
          <p>
            The office, assigned conversations, archive, and a retention log. It is supervision, not
            a DRE certification.
          </p>
        </section>
        <section className="card">
          <h2>Where does payment happen?</h2>
          <p>
            On this site, through PayPal. After checkout you return to REChecklist. The app itself
            stays a workflow.
          </p>
        </section>
        <section className="card">
          <h2>Does Open REChecklist start the Beta Tester Program?</h2>
          <p>
            No. Only a custom link given directly to an invited tester opens the program. If you
            arrived from that link, you are in the right place. Questions:{" "}
            <a href="mailto:sysadmin@rechecklist.pro">sysadmin@rechecklist.pro</a>.
          </p>
        </section>
        <section className="card">
          <h2>Where is the User Guide?</h2>
          <p>The A–Z directory is on this site under User Guide. Support is role-based: buyer, seller, agent, broker, and admin.</p>
        </section>
      </div>
    </article>
  );
}
